import client from "../../../../client";
import type { RequestConfig, ResponseErrorConfig } from "../../../../client";
import type {
  GetApiConfirmationQueryResponse,
  GetApiConfirmationQueryParams,
  GetApiConfirmation401,
  GetApiConfirmation403,
} from "../../../types/GetApiConfirmation";

export function getGetApiConfirmationUrl() {
  return `/api/Confirmation` as const;
}

/**
 * {@link /api/Confirmation}
 */
export async function getApiConfirmation(
  params?: GetApiConfirmationQueryParams,
  config: Partial<RequestConfig> & { client?: typeof client } = {}
) {
  const { client: request = client, ...requestConfig } = config;

  const res = await request<
    GetApiConfirmationQueryResponse,
    ResponseErrorConfig<GetApiConfirmation401 | GetApiConfirmation403>,
    unknown
  >({
    method: "GET",
    url: getGetApiConfirmationUrl().toString(),
    params,
    ...requestConfig,
  });
  return res;
}
